import { Deserializable } from '../deserializable';
import { FiaApplication } from './fia-application';
import { UserProfile } from './user-profile';
import { Users } from './users';

export class UserFullDetails implements Deserializable{

  public user: Users = new Users();
  public profile: UserProfile = new UserProfile();
  public fiaApplications: FiaApplication[] = [];

  public requestOrigin: string = "client";

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
